import moment from "moment";
import i18n from "../lib/i18n";

moment.locale(i18n.locale);

export function date(value) {
  return moment(value).format("MMMM Y");
}

export function dayName(value) {
  return moment(value).format("dddd");
}

export function dayNumber(value) {
  return moment(value).format("D");
}

export function dayNumberInterval(value, duration) {
  return `${moment(value).format("D.")}-${moment(value)
    .add(duration - 1, "days")
    .format("D.")}`;
}

export function dayTextInterval(value, duration) {
  return `${moment(value).format("dddd")} - ${moment(value)
    .add(duration - 1, "days")
    .format("dddd")}`;
}
